// components/Composite/CodeBlock/index.js
import CodeBlock from './CodeBlock';

export default CodeBlock;
